/**
 * Utility functions for PWA detection and installation
 */

/**
 * Checks if the app is currently running in standalone mode (installed as PWA)
 * @returns boolean indicating if the app is installed
 */
export const isPwaInstalled = (): boolean => {
  // Check if the app is in standalone mode (installed)
  const isStandalone = 
    window.matchMedia("(display-mode: standalone)").matches || 
    (window as any).navigator.standalone === true;
  
  return isStandalone;
}; 